import styled from '@emotion/styled';

export const LocalesOnFolder = styled.span`
    display: inline-flex;
    max-height: 5rem;
    overflow-y: auto;
    font-size: small;
`;